import {request} from './request';
import qs from 'qs';
import Cookies from 'js-cookie';

export function get_code(email) {
    return request({url:'/profile/sendCode.php',params:{email}});
}
export function reset_password(params){
    return  request({url:`/profile/resetPassword.php`,data:qs.stringify(params),method:'post'});
}